import styled from "styled-components";

// Reading styles for a help article. Deliberately closer to a document
// than to the dense application chrome around it — long explanations are
// read, not scanned, so the measure is narrow and the leading generous.
export const ArticleBody = styled.div`
  font-size: 15px;
  line-height: 25px;
  color: #26313f;

  h1 {
    margin: 0 0 12px;
    font-size: 26px;
    line-height: 34px;
    font-weight: 700;
    color: #12181f;
  }

  h2 {
    margin: 34px 0 10px;
    font-size: 19px;
    line-height: 26px;
    font-weight: 700;
    color: #12181f;
    scroll-margin-top: 24px;
  }

  h3 {
    margin: 24px 0 8px;
    font-size: 16px;
    line-height: 23px;
    font-weight: 700;
    color: #12181f;
    scroll-margin-top: 24px;
  }

  p {
    margin: 0 0 14px;
  }

  ul,
  ol {
    margin: 0 0 14px;
    padding-left: 22px;
  }

  li {
    margin-bottom: 6px;
  }

  strong {
    font-weight: 700;
    color: #12181f;
  }

  a {
    color: #0c53bb;
    text-decoration: none;
  }

  a:hover {
    text-decoration: underline;
  }

  table {
    border-collapse: collapse;
    width: 100%;
    margin: 16px 0 20px;
    font-size: 14px;
  }

  th,
  td {
    border: 1px solid #e3e8ef;
    padding: 9px 13px;
    text-align: left;
    vertical-align: top;
  }

  th {
    background: #f7f9fc;
    font-weight: 700;
  }

  /* Error messages and VA responses are quoted verbatim in these
     articles, so a blockquote is almost always a literal string the
     reader will compare against their screen. */
  blockquote {
    margin: 16px 0;
    padding: 12px 16px;
    border-left: 3px solid #b9c6d8;
    background: #f7f9fc;
    color: #41506a;
  }

  blockquote p:last-child {
    margin-bottom: 0;
  }

  code {
    font-family: "SF Mono", Menlo, Consolas, monospace;
    font-size: 13px;
    background: #f1f4f8;
    padding: 2px 6px;
    border-radius: 3px;
  }

  hr {
    border: none;
    border-top: 1px solid #e3e8ef;
    margin: 28px 0;
  }

  img {
    max-width: 100%;
    border: 1px solid #e3e8ef;
    border-radius: 6px;
    margin: 8px 0;
  }
`;
